<template>
  <div>
    <div class="login-sign">
      <router-link to="/signin" class="logo sign w-nav-brand"></router-link>
      <form
        @submit.prevent="submitForgotPassword()"
        class="w-form"
        id="email-form"
        name="email-form"
        data-name="Email Form"
      >
        <p class='reset_password'>לאיפוס הסיסמא אנא הזן את כתובת המייל שלך, <br/> ועקוב אחר ההוראות במייל שיישלח אליך</p>
        <input
          type="text"
          class="text-field w-input"
          maxlength="256"
          name="name"
          data-name="Name"
          placeholder="כתובת מייל"
          id="name"
          required
          v-model="email"
        />
        <div class="btn-wrapper sign">
          <input type="submit" value="איפוס סיסמא" data-wait class="btn sign w-button" />
        </div>
        <p v-if="this.signInError" class="sign-link" style="color:red">{{ this.getErrMsg }}</p>
      </form>
      <div style="text-align:center">
        <loader v-if="this.loading" />
      </div>
    </div>
  </div>
</template>


<script>
import { mapGetters } from "vuex";
import loader from "../components/loader";
export default {
  name: "forgotPassword",
  components: { loader },
  data() {
    return {
      email: "",
      loading: false,
      signInError: false
    };
  },
  methods: {
    submitForgotPassword() {
      let emailToReset = this.email;
      this.$store.dispatch("resetPassword", emailToReset);
    }
  },
  watch: {
    getLoading() {
      console.log(this.getLoading);
      switch (this.getLoading) {
        case 1:
          this.loading = true;
          break;
        case 2:
          this.$router.push("SignIn");
          break;
      case 3:
          this.signInError = true;
          this.loading = false;
          break;
      }
    }
  },
  computed: {
    ...mapGetters(["getLoading", "getErrMsg"])
  }
};
</script>